import { FaLocationDot, FaStar } from "react-icons/fa6";
import { IoFemale, IoMaleOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { Badge, Card, CardBody, Col, Row } from "reactstrap";
import { useTranslation } from "../../languages";
const MyPlaceCard = ({ details }) => {
  const navigateTo = useNavigate();
  const { t } = useTranslation();
  const renderBadgeClasses = () => {
    switch (details?.status) {
      case "active":
        return "bg-white color-primary-blue";
      case "pending":
        return "bg-warning color-primary-blue";
      case "rejected":
        return "bg-danger text-white";
    }
  };
  const renderBadgeText = () => {
    switch (details?.status) {
      case "active":
        return t("approvedText");
      case "pending":
        return t("pendingText");
      case "rejected":
        return t("rejectedText");
      default:
        return details?.status;
    }
  };
  // const getDetailsLink = () => {
  //   switch (details?.types[0]) {
  //     case "Resturant":
  //       return `/places/resturant/${details?._id}`;
  //     case "special-event":
  //       return `/places/special-event/${details?._id}`;
  //     case "kids":
  //       return `/places/kids/${details?._id}`;
  //     case "event":
  //       return `/places/event/${details?._id}`;
  //     case "date":
  //       return `/places/date/${details?._id}`;
  //     case "culture":
  //       return `/places/culture/${details?._id}`;
  //     case "sports":
  //       return `/places/sports/${details?._id}`;
  //     case "adventure":
  //       return `/places/adventure/${details?._id}`;
  //     default:
  //       return `/`;
  //   }
  // };
  const onCardClick = () => {
    // let link = getDetailsLink();
    // console.log({ link });
    const link = `/places/resturant/${details?._id}`;
    navigateTo(link, { state: details });
    console.log("Card clicked for details: ", link);
  };
  return (
    <Card onClick={() => onCardClick()} className="border-none my-place-card">
      <CardBody>
        <Row className="g-2 g-md-0">
          <Col md={4}>
            <div className="img position-relative">
              <img
                src={details?.photos[0]}
                height={220}
                className=" object-fit-cover full-width"
                style={{ borderRadius: "11px", aspectRatio: "2/1" }}
              />
              <Badge
                className={`position-absolute figma-status-badge baloo-font d-flex align-items-center justify-content-center py-2 px-4 f-5 ${renderBadgeClasses()}`}
              >
                {renderBadgeText()}
              </Badge>
            </div>
          </Col>
          <Col md={8} className="d-flex align-items-center">
            <div className="full-width m-2 m-md-3  m-xxl-4 position-relative">
              <div className="d-flex full-width  align-items-center  justify-content-between ">
                <h4 className="f-5 m-0 " style={{ whiteSpace: "nowrap" }}>
                  {details?.name}{" "}
                  {details?.genderPreference?.[0] === "male" ? (
                    <IoMaleOutline size={30} color="blue" />
                  ) : details?.genderPreference?.[0] === "female" ? (
                    <IoFemale size={30} color="rgb(157, 1, 85)" />
                  ) : (
                    ""
                  )}
                </h4>
               {details?.status?.toUpperCase()!=="REJECTED"&& <h5 className="py-2 f-5 m-0 check-ins">
                  {details?.viewers.length ?? 50} Check ins
                </h5>}
              </div>
              <h5 className="f-4 color-half-black-3 mb-3">
                {details?.types[0]}
              </h5>
              <div className="d-flex align-items-center gap-1">
                <div>
                  <FaLocationDot color="darkgreen" size={23} />
                </div>
                <h6 className="f-4 m-0">{details?.location?.streetAddress}</h6>
              </div>
              <div className="d-flex flex-wrap gap-3 gap-md-3 flex-lg-nowrap  mt-3  full-width align-items-center justify-content-between ">
                <Link
                  to={"/places/editPlace"}
                  state={details}
                  onClick={(e) => {
                    e?.stopPropagation();
                    console.log("Edit place clicked", details);
                  }}
                  style={{ borderRadius: "70px", minWidth: "50%" }}
                  className="btn color-primary-blue btn-md  border-none f-5 bg-primary-half-blue py-md-3 py-2 "
                >
                  {t("editPlace")}
                </Link>
                <h5 className="color-half-black-3 d-flex align-items-center gap-1 f-4 my-0  mx-xl-5">
                  <span style={{ lineHeight: "24px" }}>
                    {details?.reviews?.length}
                  </span>{" "}
                  <FaStar size={24} color="rgba(246, 201, 68, 1)" />
                </h5>
              </div>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
export default MyPlaceCard;
